<template>
  <div class="login_cont">
    <div class="country-tab">
      <div class="login_tab_div top">
        <span class="country-title">{{ $t('login.countryTitle') }}</span>
      </div>
      <div class="login_tab">
        <div class="login_tab_cont">
          <el-form
            ref="ruleFormCountry"
            :model="ruleFormCountry"
            :rules="rules4"
            label-width="40px"
            @submit.native.prevent
          >
            <el-form-item
              prop="countryValue"
              class="login_line line_country"
            >
              <em>*</em>
              <chooseCountry
                :country="ruleFormCountry.countryValue"
                @changeCountryValue="changeCountryValue"
                class="country-box"
              />
            </el-form-item>
            <el-button
              class="login_button"
              native-type="submit"
              @click="chooseCountry('ruleFormCountry')"
            >
              {{ $t("base.sure") }}
            </el-button>
          </el-form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import chooseCountry  from '@/components/OppleCountryChoose/chooseCountry.vue';

export default {
    components: {
        chooseCountry
    },
    props: {
        country:{
            type:String,
            default:''
        }
    },
    data () {
        const yzcountry = (rule, value, callback) => {
            if (value === '' || value === null) {
                callback(new Error(this.$t('register.countryempty')))
            } else {
                callback()
            }
        } // 验证国家
        return {
            ruleFormCountry:{
                countryValue: ''
            },
            rules4:{
                countryValue: [{ validator: yzcountry, trigger: ['blur','change'] }]
            },
        }
    },
    watch: {
        country:function(e){
            this.ruleFormCountry.countryValue = e
        },
    },
        
    mounted () {
        this.ruleFormCountry.countryValue = this.country
    },
    methods: {
        changeCountryValue(e){
            this.$emit('changeCountryValue', e)
        },
        chooseCountry(formName){
            this.$refs[formName].validate((valid) => {
                if(valid){
                    /* 填写了国家 */
                    this.$emit('handleCountryTab', false)
                }else{
                    return false
                }
            })
         },
    }
}
</script>

<style lang="scss" scoped>
.country-tab{
  position: absolute;
  top:0;
  left:0;
  height:100%;
  width:100%;
  .login_tab_div{
    margin: 30px 0;
    text-align: center;
  }
  .country-title{
    color: #fff;
    font-size: 18px;
    text-align: center;
  }
  .login_tab{
    margin-top: 30px;
  }
  .login_button{
    margin-top: 180px !important;
  }
  .line_country{
    background-position: 10px 13px !important;
  }
}

.login_cont {
    position: absolute;
    top: 50% !important;
    width: 360px;
    height: 480px !important;
    border-radius: 4px;
    background: linear-gradient(
      207deg,
      rgb(82 124 204 / 80%),
      rgb(177 200 246 / 50%)
    );
    box-shadow: 1px 40px 59px 0 rgb(40 74 151 / 43%);
    .login_logo {
      display: block;
      margin: 0 auto;
      margin-top: 50px;
      margin-bottom: 40px;
    }
    .login_tab {
      margin: 0 40px;
      .login_tab_div {
        overflow: hidden;
        margin: 0 45px;
        margin-bottom: 15px;
        height: auto;
        .login_span {
          display: inline-block;
          height: 22px;
          font-size: 16px;
          color: #ffffff;
          line-height: 22px;
        }
        .login_span_flow {
          overflow: hidden;
          width: 120px;
          white-space: nowrap;
        }
        .right {
          float: right;
          text-align: right;
        }
        .left {
          float: left;
        }
        .login_curr {
          color: #ffffff !important;
        }
        .title {
          font-size: 18px !important;
          color: $color22;
        }
        .line {
          margin-left: 20px;
          text-align: center;
          color: $color22;
        }
      }
      .top {
        padding-bottom: 28px;
      }
      .login_tab_cont {
        .login_button {
          margin-top: 40px;
          margin-bottom: 20px;
          width: 100%;
          height: 48px;
          font-size: 16px;
          border-radius: 3px;
          color: #fefefe;
          background: rgb(0 70 170 / 100%);
        }
        .login_line {
          position: relative;
          width: 100%;
          border-bottom: 1px solid $line;
          color: $color3;
          input {
            position: absolute;
            left: 45px;
            width: 60%;
            height: 100%;
            border: none;
            outline: none;
          }
          .eye {
            position: absolute;
            top: 50%;
            right: 0;
            margin-top: -5px;
          }
          .yanz {
            position: absolute;
            top: 0;
            right: 0;
            padding: 20px 15px;
          }
        }
        .agreen {
          margin-bottom: 20px;
          width: 100%;
        }
      }
      .go_button {
        display: flex;
        margin-top: 40px;
        font-size: 14px;
        text-align: center;
        color: $color2;
        .go_register {
          float: left;
          width: 50%;
          border-right: 1px solid #bed7f3;
          flex: 1;
        }
        .go_psw {
          float: left;
          width: 50%;
          flex: 1;
        }
      }
    }
  }


  
</style>

<style lang="scss">
.country-tab{
  .el-form-item__content{
    height: 44px !important;
  }
  .country-box .countryPane .el-input--small .el-input__inner{
    text-align: left !important;
    padding-left: 25px;
  }
   .login_tab_cont .el-input{
    margin-top: 7px !important;
  }
  .countryPane .el-select{
    width: 230px !important;
  }
  .el-icon-circle-check{
    display: none !important;
  }
}
</style>